import { useState, useEffect, useContext } from "react";
import { ArticleContext, CategoryContext } from "../index";
import {
  getArticles,
  getParticularArticle,
} from "../../Service/ArticleService";

export default function ArticleProvider(props) {
  const { categoryData, categoryList } = useContext(CategoryContext);

  const [categorySlug, setCategorySlug] = useState(false);
  const [articleSlug, setArticleSlug] = useState(false);

  const [articleData, setArticleData] = useState([]);
  const [selectedArticle, setSelectedArticle] = useState(true);

  useEffect(() => {
    if (categorySlug) {
      setArticleData([]);
      getArticles(categorySlug)
        .then((res) => {
          if (res?.data?.data?.articles?.length > 0) {
            setArticleData(res?.data?.data?.articles);
          } else {
            setArticleData([]);
          }
        })
        .catch((rej) => {
          setArticleData(false);
        });
    }
  }, [categoryData, categorySlug]);

  useEffect(() => {
    if (articleSlug) {
      getParticularArticle(articleSlug)
        .then((res) => {
          const { data } = res?.data || {};
          const { categoryId } = data || {};
          const validCategorySlug = Array.isArray(categoryList) && categoryList.find(item => categoryId === item.categoryId);
          const isValid = validCategorySlug?.slug === categorySlug;
          if (!data || !categoryId || !isValid) {
            setSelectedArticle(false);
            return;
          }
          setSelectedArticle(data);
        })
        .catch((_rej) => {
          setSelectedArticle(false);
        });
      }
    }, [articleSlug]);
    
  return (
    <ArticleContext.Provider
      value={{
        articleData: articleData,
        setArticleData: setArticleData,
        setSelectedArticle,
        selectedArticle,
        categorySlug,
        setCategorySlug,
        articleSlug,
        setArticleSlug,
      }}
    >
      {props.children}
    </ArticleContext.Provider>
  );
}
